import { render, staticRenderFns } from "./StudioSearch.vue?vue&type=template&id=d80351b8&"
import script from "./StudioSearch.vue?vue&type=script&lang=js&"
export * from "./StudioSearch.vue?vue&type=script&lang=js&"
import style0 from "./StudioSearch.vue?vue&type=style&index=0&id=d80351b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports